import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { PaymentOptionType, PaymentOptionView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerPaymentOptions } from "@/lib/query/core/invalidation";

type UpsertPaymentOptionInput = {
  storeSlug: string;
  detailId?: string;
  type: PaymentOptionType;
  isActive: boolean;
  entries: Array<{
    labelAr: string;
    labelEn: string;
    value: string;
  }>;
};

export function useUpsertPaymentOptionMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: UpsertPaymentOptionInput) => {
      const { storeSlug, detailId, ...body } = input;
      void storeSlug;
      return apiJsonClient<PaymentOptionView>(
        detailId ? endpoints.seller.paymentOptionById(detailId) : endpoints.seller.paymentOptions,
        {
          method: detailId ? "PATCH" : "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        },
      );
    },
    onSuccess: async (_data, variables) => {
      await invalidateSellerPaymentOptions(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
